import Alt from "alt";
var alt = new Alt(); // DEBUG log all action events
// alt.dispatcher.register(console.log.bind(console, 'alt.dispatcher'))
// For debugging alt stores https://github.com/goatslacker/alt-devtool
//Alt.debug("alt", alt);

export default alt;